const languageJson = {
  'zh-CN': {
    pagetitle: '我的账户',
    userdetail:'账户信息',
    username: '账户名',
    name: '姓名',
    unset: '未设置',
    accountself: '账户安全',
    password: '密码',
    rewritePassword: '修改密码',
    phone: '手机号',
    email: '邮箱',
    unbind: '未绑定',
    change: '更换',
    link: '设置',
    bindnone: '解除绑定',
    bind: '绑定',
    // 修改密码
    changepassword: '修改密码',
    oldpassword: '原密码',
    oldpasswordP: '请输入原始密码',
    newpassword: '新密码',
    newpasswordP: '至少8位，需包含大小写字母和数字',
    conpassword: '确认密码',
    conpasswordP: '确认新密码',
    submit: '确 定',
    bindphone: '绑定手机号',
    changephone: '更换手机号',
    bindemail: '绑定邮箱',
    changeemail: '更换邮箱',
    edit: '编辑',
    save: '保存',
    cancle: '取 消',
    dphone: '手机号',
    demail: '邮箱',
    phonePlace: '请输入手机号',
    emailPlace: '请输入邮箱',
    code: '验证码',
    codePlace: '请输入验证码',
    timeTips: 's后重新发送',
    send: '发送验证码',
    wechat: '微信登录',
    weibo: '微博扫码登录',
    orcidlogin: 'ORCID登录',
    ding_talk_login: '钉钉扫码登录',
    unlink: '解除绑定',
    unlinktips: '解除绑定后，将无法使用',
    login: '登录，确定要解绑吗？',
    wcscan: '微信扫码',
    wbcan: '微博扫码',
    orcid: 'ORCID',
    ding_talk: '钉钉扫码',
    inputtips1: '请输入手机号',
    inputtips2: '请输入格式正确的手机号码',
    inputtips3: '请输入邮箱地址',
    inputtips4: '请输入格式正确的邮箱地址',
    inputtips5: '请输入新密码',
    inputtips6: '至少8位，需包含大小写字母和数字',
    inputtips7: '请输入确认密码',
    inputtips8: '两次密码输入不一致',
    inputtips9: '请输入用户名',
    inputtips10: '请输入原密码',
    inputtips11: '请输入验证码',
    binded: '已绑定',
    sendSuccess: '发送成功',
    // 我的应用
    apptitle: '我的应用',
    appname: '应用名称',
    appurl: '访问地址',
    appstate: '启用状态',
    emptyText: '暂无数据'
  },
  'en': {
    pagetitle: 'My Account',
    userdetail:'Personal info',
    username: 'Username',
    name: 'Nickname',
    accountself: 'Account security',
    password: 'Password',
    rewritePassword: 'Update',
    phone: 'Phone',
    email: 'Email',
    unbind: 'Not Linked',
    change: 'Update',
    link: 'Link',
    bindnone: 'Unlink',
    bind: 'Link',
    // 修改密码
    changepassword: 'Update Password',
    oldpassword: 'Current  Password',
    oldpasswordP: '',
    newpassword: 'New Password',
    newpasswordP: '',
    conpassword: 'Confirm Password',
    conpasswordP: '',
    submit: 'OK',
    bindphone: 'Link Phone',
    changephone: 'Update Phone',
    bindemail: 'Link Email',
    changeemail: 'Update Email',
    unset: '',
    edit: 'Update',
    save: 'Save',
    cancle: 'Cancel',
    dphone: 'Phone',
    demail: 'Email',
    phonePlace: '',
    emailPlace: '',
    code: 'Verification Code',
    codePlace: '',
    timeTips: 's',
    send: 'Send',
    wechatopen: 'WeChat',
    weibo: 'weibo',
    orcidlogin: 'ORCID',
    unlink: 'Unlink Social Accounts',
    unlinktips: 'After unlinking, you will not be able to use',
    login: 'to log in to your current account. Are you sure you want to unlink?',
    wcscan: 'WeChat scan',
    wbcan: 'Weibo code scan',
    orcid: 'ORCID',
    inputtips1: 'Please enter your phone',
    inputtips2: 'Please enter a valid phone',
    inputtips3: 'Please enter your email ',
    inputtips4: 'Please enter a valid email',
    inputtips5: 'Please set your password',
    inputtips6: 'Use 8 or more characters with a mix of uppercase letters, lowercase letters & numbers',
    inputtips7: 'Please confirm your password',
    inputtips8: 'Your passwords do not match',
    inputtips9: 'Please set your username ',
    inputtips10: 'Please enter the original password',
    inputtips11: 'Please enter the verification code',
    binded: 'Bound',
    sendSuccess: 'A verification code has been sent',
    // 我的应用
    apptitle: 'My Applications',
    appname: 'Name',
    appurl: 'URL',
    appstate: 'Status',
    emptyText: 'No data available at the moment'
  }
}
const language = getUrlParms('language')
function getUrlParms (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if(r != null)
  return unescape(r[2]);
  return null;
}
let currentLanguage = language === "en" ? languageJson.en : languageJson.cn
export default { currentLanguage, language, languageJson }